import { TOtp } from "@components/types";
import { handleResponse, SERVER_HOST } from "@api";
import axios from "axios";


export const generateOtp = async (otp: TOtp) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/otp/generate`,
        JSON.stringify(otp),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const generateOtpOtp = async (id: number, otp: TOtp) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/otp/verify/${id}`,
        JSON.stringify(otp),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const verifyWhatsappOtp = async (otp_id: number, otp: number) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/whatsapp/verify/?otp_id=${otp_id}&otp=${otp}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}